import { render, staticRenderFns } from "./CreateSupplierBrand.vue?vue&type=template&id=2b5b45b8&scoped=true"
import script from "./CreateSupplierBrand.vue?vue&type=script&lang=js"
export * from "./CreateSupplierBrand.vue?vue&type=script&lang=js"
import style0 from "./CreateSupplierBrand.vue?vue&type=style&index=0&id=2b5b45b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b45b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5b45b8')) {
      api.createRecord('2b5b45b8', component.options)
    } else {
      api.reload('2b5b45b8', component.options)
    }
    module.hot.accept("./CreateSupplierBrand.vue?vue&type=template&id=2b5b45b8&scoped=true", function () {
      api.rerender('2b5b45b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/CreateSupplierBrand.vue"
export default component.exports